export const ONE_SECOND = 1000
export const API = process.env.REACT_APP_API_URL || 'https://api.dev.piligrim.tech/api/';

export enum PackageType {
  RECEIVING = 'RECEIVING',
  SHIPPING = 'SHIPPING'
}

export enum ReceivingStatus {
  ALL = "all",
  NEW = "new",
  ON_THE_WAY = "on_the_way",
  ARRIVED = "arrived",
  UNLOADING = "unloading",
  UNLOADED = "unloaded"
}

export enum ShippingStatus {
  ALL = "all",
  NEW = "new",
  ON_THE_WAY = "on_the_way",
  ARRIVED = "arrived",
  FORMING = "forming",
  DISPATCHED = "dispatched",
}

export const receivingStatusLabels = {
  [ReceivingStatus.ALL]: 'Все',
  [ReceivingStatus.NEW]: "Новый",
  [ReceivingStatus.ON_THE_WAY]: "В пути",
  [ReceivingStatus.ARRIVED]: "Прибыл",
  [ReceivingStatus.UNLOADING]: "На разгрузке",
  [ReceivingStatus.UNLOADED]: "Разгружен",
};

export const shippingStatusLabels = {
  [ShippingStatus.ALL]: 'Все',
  [ShippingStatus.NEW]: "Новый",
  [ShippingStatus.ON_THE_WAY]: "В пути",
  [ShippingStatus.ARRIVED]: "Доставлен",
  [ShippingStatus.FORMING]: "Формируется",
  [ShippingStatus.DISPATCHED]: "Отправлен",
};

// Статусы упрощённой отгрузки (CustomSimplifiedShippingStatusEnum на бэкенде).
export enum SimplifiedShippingStatus {
  CREATED = "created",
  IN_TRANSIT = "in_transit",
  DELIVERED_TO_TERMINAL = "delivered_to_terminal",
}

export const simplifiedShippingStatusLabels = {
  [SimplifiedShippingStatus.CREATED]: "Создана",
  [SimplifiedShippingStatus.IN_TRANSIT]: "В пути",
  [SimplifiedShippingStatus.DELIVERED_TO_TERMINAL]: "Доставлено на терминал",
};

export enum ContainerStatus {
  CANCELLED = 'Отменён',
  NEW = 'Новый',
  SLOT_ASSIGNED = 'Окно назначено',
  DRIVER_ASSIGNED = 'Водитель назначен',
  AWAITING_DRIVER = 'Ожидает водителя',
  DRIVER_EN_ROUTE = 'Водитель в пути',
  ON_THE_WAY = 'В пути',
  PROCESSING = 'Обработка',
  DELIVERED = 'Доставлен',
  DELIVERED2 = 'Прибыл'
}

export const packageNum = [
  { id: "A", label: "A" },
  { id: "B", label: "B" },
  { id: "C", label: "C" },
];

export const condition = [
  {
    id: "Обязательно",
    label: "Обязательно"
  },
  {
    id: "Необязательно",
    label: "Необязательно"
  },
]

export const address = [
  { id: "1", label: "г.Москва, ул Ленина, дом 1, пом. 25" },
  { id: "2", label: "г.Санкт-Петербург, ул Ленина, дом 1, пом. 25" },
  { id: "3", label: "г.Новосибирск, ул Ленина, дом 1, пом. 25" },
];

export const time = [
  { id: "9:00-12:00", label: "9:00-12:00" },
  { id: "13:00-18:00", label: "13:00-18:00" },
];

